import React from 'react';
import styles from './style.module.css';
import { Link } from 'react-router-dom';

export default ({
    title = '',
    content = '',
    additionalContent = null,
    icon = 'lightbulb',
    button = false
} = {}) => (
    <div className={styles.container} role='region' aria-label={title}>
        <p className={icon ? styles.titleIcon : styles.title}>
            {
                icon &&
                <span className={styles[icon]}/>
            }
            {title}
        </p>
        <p className={styles.text}>{content}</p>
        {
            additionalContent &&
                <p className={styles.additionalText}>{additionalContent}</p>
        }
        {
            button && button.link && button.label &&
            <div className={styles.buttonWrap}>
                <Link
                    to={button.link}
                    onClick={button.onClick ? button.onClick : null}
                    className={styles.button}
                    title={button.title ? button.title : button.label}
                    target={button.target ? button.target : null}
                >
                    {button.label}
                </Link>
            </div>
        }
    </div>
);
